<template>
    <div>            
        <LongdoMap :center="map.center" :apiKey="map.apiKey">

        </LongdoMap>

    </div>
</template>

<script>
import { LongdoMap, LongdoMapMarker } from 'longdo-map-vue'
 
export default {
  name: 'app',
  components: {
    LongdoMap,
    LongdoMapMarker,
    },
    data:{
        map: {
            apiKey: 'bc9689f8772e5fbdd243e1c430d49aba' ,// API Key
            center: {
                lon: 100,
                lat: 16
            }
        }
    },
    created () {
        this.read_day()
        console.log(' read '+this.markers)
    },

    methods :{
        read_day() {
                const vm = this;
                vm.axios.get('https://ws.plantifulbkk.shop/get_date_week.php').then(response => {
                var result = JSON.parse(JSON.stringify(response.data))
                vm.items = result
            });
        },
        read_data( date) {
                const vm = this;
                vm.markers = null

                vm.axios.get("https://ws.plantifulbkk.shop/get_customer_map.php",{
                    params: {
                        scode: date ,
                    }
                }).then(response=>{
                    var result = JSON.parse(JSON.stringify(response.data))
                    vm.markers = result
                    });
            
        },
        refr_data(){
            this.read_data()
        },
    }    
}

</script>



// WEBPACK FOOTER //
// src/pages/maporder1.vue